import { CustomMap } from '@vendor/libs/maps/maps';
import { ApiaryFeatures, AssociationBoundaryFeatures, InfectionFeatures, } from '@vendor/libs/maps/features';
import { OverlayFeatureAddon } from '@vendor/libs/maps/features/addons';
import { AsyncFeatures } from '@vendor/libs/maps/features/async-features';
import { LayersAndBaseInterfaceElement } from '@vendor/libs/maps/interface-elements/layers-and-base';
const _MapComponentHandler = (function () {
    const initializeMap = (id, options) => {
        const map = new CustomMap(id);
        if (options.fitTo) {
            map.fitTo(options.fitTo);
        }
        else {
            map.setView([18.5, 52], 6);
        }
        const element = $('#' + id);
    };
    const setLayerVisibility = (mapId, name, state) => {
        LayersAndBaseInterfaceElement.setVisibleStatic(mapId, name, state);
    };
    const addAssociationBoundaryFeatures = (mapId, data, options = {}) => {
        options = {
            ...{
                fit: false,
                highlighted: [],
            },
            ...options,
        };
        const map = CustomMap.getMap(mapId);
        if (!map) {
            return;
        }
        const associationBoundaryFeatures = new AssociationBoundaryFeatures();
        map.addFeatures('association-boundaries', associationBoundaryFeatures);
        for (let geojson of data) {
            if ((options.highlighted ?? []).includes(geojson.id)) {
                geojson.properties = {
                    ...(geojson.properties ?? {}),
                    highlighted: true,
                };
            }
            associationBoundaryFeatures.fromGeoJSON(geojson);
        }
        if (options.fit) {
            associationBoundaryFeatures.fit();
        }
    };
    const addInfectionFeatures = (mapId, data, options = {}) => {
        options = {
            ...{
                fit: false,
                highlighted: [],
            },
            ...options,
        };
        const infectionFeatures = new InfectionFeatures();
        for (let geojson of data) {
            if ((options.highlighted ?? []).includes(geojson.id)) {
                geojson.properties = {
                    ...(geojson.properties ?? {}),
                    highlighted: true,
                };
            }
            infectionFeatures.fromGeoJSON(geojson);
            const features = infectionFeatures.fromGeoJSON(geojson);
            const relatedFeatures = infectionFeatures.related.filter((feature) => features
                .map((feature) => feature.getId())
                .includes(feature.get('related_to')));
            for (const feature of relatedFeatures) {
                feature.set('highlighted', true);
            }
        }
        const map = CustomMap.getMap(mapId);
        if (!map) {
            return;
        }
        map.addFeatures('infections', infectionFeatures);
        if (options.fit) {
            infectionFeatures.fit();
        }
    };
    const addApiaryFeatures = (mapId, data, options = {}) => {
        options = {
            ...{
                fit: false,
                overlay: true,
                apiaries: [],
                highlighted: [],
            },
            ...options,
        };
        const apiaryFeatures = new ApiaryFeatures();
        for (let geojson of data) {
            if ((options.highlighted ?? []).includes(geojson.id)) {
                geojson.properties = {
                    ...(geojson.properties ?? {}),
                    highlighted: true,
                };
            }
            apiaryFeatures.fromGeoJSON(geojson);
        }
        const map = CustomMap.getMap(mapId);
        if (!map) {
            return;
        }
        map.addFeatures('apiaries', apiaryFeatures);
        if (options.overlay && options.apiaries && options.apiaries.length > 0) {
            apiaryFeatures.addAddon('overlay', new OverlayFeatureAddon({
                render: ({ feature }) => {
                    const apiary = options.apiaries &&
                        options.apiaries.find((a) => a.id === feature.getId());
                    if (!apiary) {
                        return null;
                    }
                    return ApiaryFeatures.getOverlayHtml(apiary);
                },
            }));
        }
        if (options.fit) {
            apiaryFeatures.fit();
        }
    };
    const addAsyncFeatures = (mapId, options = {}) => {
        const map = CustomMap.getMap(mapId);
        if (!map) {
            return;
        }
        map.addFeatures('async-features', new AsyncFeatures(options));
    };
    const on = (mapId, event, callback) => {
        CustomMap.on(mapId, event, callback);
    };
    return {
        // Public functions
        init: function () { },
        initializeMap,
        addApiaryFeatures,
        addInfectionFeatures,
        addAssociationBoundaryFeatures,
        addAsyncFeatures,
        setLayerVisibility,
        on,
    };
})();
window.MapComponentHandler = _MapComponentHandler;
